const forbiddenPhones = {
    '00000000' : true,
    '000000000' : true,
    '11111111' : true,
    '12345678' : true,
    '22222222' : true,
    '33333333' : true,
    '44444444' : true,
    '55555555' : true,
    '66666666' : true,
    '77777777' : true,
    '87654321' : true,
    '88888888' : true,
    '98765432' : true,
    '987654321' : true,
    '99999999' : true,
};

const forbiddenDomains = {
    'A' : true,
    'CLIENTE.COM' : true,
    'CLIENTE.COM.BR' : true,
    'NAO.COM' : true,
    'NAO.COM.BR' : true,
    'NC' : true,
    'NAOSEI.COM' : true,
    'NAOSEI.COM.BR' : true,
    'NAOTEM' : true,
    'NAOTEM.COM' : true,
    'NAOTEM.COM.BR' : true,
    'NT.COM' : true,
    'NT.COM.BR' : true,
    'NÃOTEM' : true,
    'NÃOTEM.COM' : true,
    'TESTE.COM' : true,
    'TESTE.COM.BR' : true,
    'VCIMENTOS.COM' : true,
    'VCIMENTOS.COM.BR' : true,
    'VOTORAN.COM' : true,
    'VOTORAN.COM.BR' : true,
    'VOTORANTIM.COM' : true
}

const forbiddenEmailNames = {
    'A' : true,
    'ACBDE' : true,
    'CLIENTE' : true,
    'NAO' : true,
    'NAOTEM' : true,
    'NC' : true,
    'NT' : true,
    'NÃO SEI' : true,
    'NÃOTEM' : true,
    'SDSDSDS' : true,
    'SEM_EMAIL' : true,
    'TESTE' : true,
    'vcimentos': true,
}

const forbiddenEmails = {
    'NC@NC.COM' : true,
    'SEM_EMAIL@MAIL.COM' : true

}

export {
    forbiddenPhones,
    forbiddenDomains,
    forbiddenEmailNames,
    forbiddenEmails
}